import type { ReactNode } from 'react';

/** Window CustomEvent name the shell's ExtensibilityZone listens on. */
export const INJECT_TOPBAR_EVENT = 'inject-topbar';

/**
 * Pushes content into the shell's top-bar `ExtensibilityZone` (zoneId="topbar").
 * The zone listens for `inject-topbar` CustomEvents and renders `injectedContent`.
 */
export const injectTopbar = (injectedContent: ReactNode): void => {
	window.dispatchEvent(
		new CustomEvent(INJECT_TOPBAR_EVENT, { detail: { injectedContent } })
	);
};
